import { render } from "./RemoteHelp.vue?vue&type=template&id=c10e8058"
import script from "./RemoteHelp.vue?vue&type=script&lang=js"
export * from "./RemoteHelp.vue?vue&type=script&lang=js"

import exportComponent from "/home/brant/git/HeySensCloudWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__